import { Flex, Grid } from 'antd';
import { CoyuLogo } from '@admin-panel/components';
import * as Styles from './styles';

type AuthLayoutProps = {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  children: React.ReactNode;
  consoleName: 'NEXUS' | 'HUB' | 'FOUNDATION' | 'SYNQ' | 'RIDERS';
  brandColor?: string;
};

export const AuthLayout = ({ title, subtitle, children, consoleName, brandColor }: AuthLayoutProps) => {
  const screens = Grid.useBreakpoint();
  const isMobile = !screens.md;

  return (
    <Styles.Root $isMobile={isMobile}>
      {!isMobile && (
        <Styles.LeftPanel $accentColor={brandColor}>
          <Styles.LeftContent>
            <Flex vertical>
              <Styles.BrandTitle>{consoleName}</Styles.BrandTitle>
              <Styles.Byline>
                <span>by</span>
                <CoyuLogo height={48} />
              </Styles.Byline>
            </Flex>
          </Styles.LeftContent>
        </Styles.LeftPanel>
      )}
      <Styles.RightPanel $isMobile={isMobile}>
        <Styles.RightContent
          $isMobile={isMobile}
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: consoleName === 'FOUNDATION' ? 'center' : 'stretch',
            textAlign: consoleName === 'FOUNDATION' ? 'center' : 'left',
          }}
        >
          <Styles.Title level={4}>{title}</Styles.Title>
          {subtitle ? <Styles.Subtitle type="secondary">{subtitle}</Styles.Subtitle> : null}
          <Styles.FormStack>{children}</Styles.FormStack>
        </Styles.RightContent>
      </Styles.RightPanel>
    </Styles.Root>
  );
};

export default AuthLayout;
